import { render, staticRenderFns } from "./MfEditor.vue?vue&type=template&id=3708231c&scoped=true&"
import script from "./MfEditor.vue?vue&type=script&lang=js&"
export * from "./MfEditor.vue?vue&type=script&lang=js&"
import style0 from "./MfEditor.vue?vue&type=style&index=0&id=3708231c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3708231c",
  null
  
)

export default component.exports